export default function About() {
  return (
    <section id="hakkimizda" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Top label */}
        <div className="flex items-center gap-3 mb-16">
          <div className="w-8 h-px bg-orange-500"></div>
          <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">Biz Kimiz</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Content */}
          <div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-none mb-8">
              25 YILDIR
              <br />
              <span className="text-transparent" style={{ WebkitTextStroke: '1px rgba(0,0,0,0.2)' }}>
                SAHADAYIZ
              </span>
              <br />
              <span className="text-orange-500">GÜVENLE.</span>
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              İş makinaları sadece metal ve dişliden ibaret değildir; bizim için her makina bir emek,
              her parça ise o emeğin kesintisiz sürmesini sağlayan bir güvencedir.
            </p>
            <p className="text-gray-500 leading-relaxed mb-10">
              Komatsu'dan Caterpillar'a, Volvo'dan Hidromek'e kadar dünya devlerinin yedek parça
              tedariğinde çeyrek asrı geride bıraktık. Uzman kadromuzla sadece parça satmıyor;
              işinizin aksamaması için çözüm üretiyoruz.
            </p>

            {/* Manifesto box */}
            <div className="border-l-2 border-orange-500 pl-6 mb-10">
              <p className="text-gray-900 font-semibold text-lg leading-relaxed">
                "Kalite bizim için bir seçenek değil, bir sözdür."
              </p>
              <p className="text-gray-500 text-sm mt-2">
                Orijinal, OEM veya yan sanayi — kapımızdan giren her parça en yüksek
                kalite standartlarını karşılar.
              </p>
            </div>

            {/* Two cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              <div className="bg-gray-50 border border-gray-200 p-6 rounded-sm">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-question-line text-orange-500 text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 text-sm mb-2 uppercase tracking-wider">Neden Buradayız?</h3>
                <p className="text-gray-500 text-xs leading-relaxed">
                  Sahadaki gücünüze güç katmak için. Sadece tedarikçi değil, güvenilir yol arkadaşı olmak için.
                </p>
              </div>
              <div className="bg-orange-500 p-6 rounded-sm">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-rocket-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-white text-sm mb-2 uppercase tracking-wider">Hedefimiz</h3>
                <p className="text-orange-100 text-xs leading-relaxed">
                  Yedek parça sektöründe dürüstlük ve kalite denince akla gelen ilk isim olmak.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => document.querySelector('#hizmetler')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gray-900 hover:bg-gray-800 text-white font-bold px-8 py-3.5 rounded-sm transition-colors duration-200 whitespace-nowrap cursor-pointer uppercase tracking-widest text-xs"
              >
                Hizmetlerimiz
              </button>
              <button
                onClick={() => document.querySelector('#iletisim')?.scrollIntoView({ behavior: 'smooth' })}
                className="border border-gray-300 hover:border-orange-500 text-gray-600 hover:text-orange-500 font-semibold px-8 py-3.5 rounded-sm transition-all duration-200 whitespace-nowrap cursor-pointer uppercase tracking-widest text-xs"
              >
                İletişime Geç
              </button>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative overflow-hidden rounded-sm h-full min-h-[480px]">
            <img
              src="https://readdy.ai/api/search-image?query=heavy%20equipment%20spare%20parts%20warehouse%20interior%20organized%20metal%20shelves%20with%20mechanical%20components%20industrial%20storage%20facility%20professional%20lighting%20bright%20clean%20atmosphere%20warm%20orange%20accent%20lighting%20industrial%20environment&width=800&height=500&seq=aboutwhite01&orientation=landscape"
              alt="Yedek Parça Deposu"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-white/40 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                <span className="text-gray-900 text-xs font-semibold uppercase tracking-widest bg-white/80 px-2 py-0.5 rounded-sm">
                  Sancaktepe, İstanbul
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
